import { postWithAuth } from '../InitializeService';
import { AxiosInstance } from 'axios';
export interface IExecuteProcReq {
    database: string;
    schema: string;
    procedure: string;
    parameters: Record<string, any>;
}
export const executeProc = (instance: AxiosInstance, req: IExecuteProcReq) => {
  instance.defaults.headers.common['x-api-key'] = '8kOU_IbKXCgx5fB2ktSC7-S31C8w2pu0mMo69k59VUg';
  return postWithAuth('procedures/execute', req, instance);
}
